import { state, els } from "./state.js";
import { toggleMapLoading } from "../../shared/map/loading-utils.js";

export function toggleLoading(isLoading) {
  // Use shared loading utility for consistency
  return toggleMapLoading(isLoading);
}

/**
 * Safely call bounce() method on a marker
 * @param {L.Marker} marker - The Leaflet marker
 * @param {Object} options - Bounce options (duration, height, etc.)
 * @returns {boolean} - True if bounce was called successfully, false otherwise
 */
export function safeBounce(marker, options = { duration: 500, height: 100 }) {
  try {
    if (!marker) {
      console.warn("safeBounce: Marker is null or undefined");
      return false;
    }

    if (typeof marker.bounce === "function") {
      marker.bounce(options);
      return true;
    } else {
      console.warn(
        "safeBounce: bounce() method not available on marker. Smooth Marker Bouncing plugin may not be loaded.",
      );
      return false;
    }
  } catch (error) {
    console.error("safeBounce: Error calling bounce() method:", error);
    return false;
  }
}

export function getCookie(name) {
  var cookies = document.cookie.split(";");
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    var cookiePair = cookie.split("=");

    if (name == cookiePair[0]) {
      return decodeURIComponent(cookiePair[1]);
    }
  }
  return null;
}

export function createDiacriticPattern(text) {
  const diacriticMap = {
    a: "[aàáảãạăằắẳẵặâầấẩẫậ]",
    ă: "[ăằắẳẵặ]",
    â: "[âầấẩẫậ]",
    e: "[eèéẻẽẹêềếểễệ]",
    ê: "[êềếểễệ]",
    i: "[iìíỉĩị]",
    o: "[oòóỏõọôồốổỗộơờớởỡợ]",
    ô: "[ôồốổỗộ]",
    ơ: "[ơờớởỡợ]",
    u: "[uùúủũụưừứửữự]",
    ư: "[ưừứửữự]",
    y: "[yỳýỷỹỵ]",
    d: "[dđ]",
    đ: "[đ]",
    // Uppercase variants
    A: "[AÀÁẢÃẠĂẰẮẲẴẶÂẦẤẨẪẬ]",
    Ă: "[ĂẰẮẲẴẶ]",
    Â: "[ÂẦẤẨẪẬ]",
    E: "[EÈÉẺẼẸÊỀẾỂỄỆ]",
    Ê: "[ÊỀẾỂỄỆ]",
    I: "[IÌÍỈĨỊ]",
    O: "[OÒÓỎÕỌÔỒỐỔỖỘƠỜỚỞỠỢ]",
    Ô: "[ÔỒỐỔỖỘ]",
    Ơ: "[ƠỜỚỞỠỢ]",
    U: "[UÙÚỦŨỤƯỪỨỬỮỰ]",
    Ư: "[ƯỪỨỬỮỰ]",
    Y: "[YỲÝỶỸỴ]",
    D: "[DĐ]",
    Đ: "[Đ]",
    " ": "[ ]", // space character
  };

  return text
    .split("")
    .map((char) => diacriticMap[char] || char)
    .join("");
}

export function findMarkerByLatLng(lat, lng) {
  console.log("🔍 Finding marker for coordinates:", lat, lng);
  console.log("📊 Total markers in state:", state.markers.length);

  // First, try to find in state.markers array (preferred method)
  for (const marker of state.markers) {
    if (marker && marker.getLatLng) {
      const markerLatLng = marker.getLatLng();
      console.log("📍 Checking marker at:", markerLatLng.lat, markerLatLng.lng);

      // Use exact coordinate comparison
      if (
        Math.abs(markerLatLng.lat - lat) < 0.000001 &&
        Math.abs(markerLatLng.lng - lng) < 0.000001
      ) {
        console.log("✅ Found marker in state.markers array");
        return marker;
      }
    }
  }

  // Fallback: try to find in map layers
  if (state.map && state.map._layers) {
    console.log("🔄 Fallback: searching in map layers");
    const layers = state.map._layers;
    for (const id in layers) {
      const layer = layers[id];
      if (layer instanceof L.Marker) {
        const markerLatLng = layer.getLatLng();
        if (
          Math.abs(markerLatLng.lat - lat) < 0.000001 &&
          Math.abs(markerLatLng.lng - lng) < 0.000001
        ) {
          console.log("✅ Found marker in map layers");
          return layer;
        }
      }
    }
  }

  console.log("❌ Marker not found for coordinates:", lat, lng);
  return null;
}
